'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useChatController } from "./internals/useChatController/index.js";
import { useChatInstance } from "./internals/useChatInstance/index.js";
import { ChatRuntimeContext } from "./internals/useChatRuntimeContext/index.js";
import { defaultPartRenderers } from "./renderers/defaultPartRenderers.js";
import { ChatStoreContext } from "./internals/useChatStoreContext/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ChatProvider(props) {
  const {
    children,
    adapter,
    onToolCall,
    onFinish,
    onData,
    onError,
    streamFlushInterval,
    partRenderers,
    storeClass,
    members,
    currentUser,
    messages,
    initialMessages,
    conversations,
    initialConversations,
    activeConversationId,
    initialActiveConversationId,
    composerValue,
    initialComposerValue,
    onMessagesChange,
    onConversationsChange,
    onActiveConversationChange,
    onComposerValueChange
  } = props;
  const parameters = React.useMemo(() => ({
    members,
    currentUser,
    messages,
    initialMessages,
    conversations,
    initialConversations,
    activeConversationId,
    initialActiveConversationId,
    composerValue,
    initialComposerValue,
    onMessagesChange,
    onConversationsChange,
    onActiveConversationChange,
    onComposerValueChange
  }), [members, currentUser, messages, initialMessages, conversations, initialConversations, activeConversationId, initialActiveConversationId, composerValue, initialComposerValue, onMessagesChange, onConversationsChange, onActiveConversationChange, onComposerValueChange]);
  const store = useChatInstance(parameters, storeClass);
  const actions = useChatController({
    store,
    adapter,
    onToolCall,
    onFinish,
    onData,
    onError,
    streamFlushInterval
  });
  const mergedPartRenderers = React.useMemo(() => _extends({}, defaultPartRenderers, partRenderers), [partRenderers]);
  const runtimeContextValue = React.useMemo(() => ({
    adapter,
    onToolCall,
    onFinish,
    onData,
    onError,
    partRenderers: mergedPartRenderers,
    actions
  }), [actions, adapter, mergedPartRenderers, onToolCall, onFinish, onData, onError]);
  return /*#__PURE__*/_jsx(ChatStoreContext.Provider, {
    value: store,
    children: /*#__PURE__*/_jsx(ChatRuntimeContext.Provider, {
      value: runtimeContextValue,
      children: children
    })
  });
}